module.exports = __webpack_public_path__ + "static/img/dotpay_logo.3db7213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dotpay_logo.png
// module id = 549
// module chunks = 2